import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { getDoorTypeDisplayLabel } from "app/data/city-delivery/dispatch-board/models";

const columnHelper = createColumnHelper<any>();

export const getDoorColumns = (assignedDoorNumber?: string) => [
  columnHelper.display({
    id: "select",
    header: "",
    cell: (cellProps) => {
      return (
        <div style={{ textAlign: "center" }}>
          <input
            type="radio"
            name="contactSelect"
            checked={cellProps.row.original.doorNumber === assignedDoorNumber}
            className="xgs-contact-card__radio"
          />
        </div>
      )
    },
    size: 40,
  }),
  columnHelper.accessor("doorNumber", {
    id: "doorNumber",
    header: "Door",
    size: 90,
  }),
  columnHelper.accessor("doorType", {
    id: "doorType",
    header: "Door Type",
    size: 153,
    cell: (cellProps) => getDoorTypeDisplayLabel(cellProps.row.original.doorType ?? ""),
  }),
  columnHelper.accessor("primaryDistributorNumber", {
    id: "primaryDistributorNumber",
    cell: (cellProps) => (
        <>
          {(cellProps.row.original.primaryDistributorNumber) ? 
            `${cellProps.row.original.primaryDistributorName} (${cellProps.row.original.primaryDistributorNumber})` 
            : ""
          }
        </>
      ),
    header: "Distributor",
    
    size: 228,
  }),
  columnHelper.accessor("trailerNumber", {
    id: "trailerNumber",
    header: "Trailer",
    size: 153,
  }),
  columnHelper.accessor("carrierNumber", {
    id: "carrierNumber",
    header: "Carrier",
    cell: (cellProps) => (
        <>
          {(cellProps.row.original.carrierNumber) ? 
            `${cellProps.row.original.carrierName} (${cellProps.row.original.carrierNumber})` 
            : ""
          }
        </>
      ),
    size: 153,
  }),
 
];